import { injector } from '../../ng-injector'

export interface ToasterOptions {
  dismissButton?: boolean
  dismissOnClick?: boolean
  dismissOnTimeout?: boolean
  extendedTimeOut?: number
  progressBar?: boolean
  tapToDismiss?: boolean
  timeOut?: number
}

export const logInfo = (message: string, toasterOptions?: ToasterOptions) =>
  injector &&
  injector.invoke(['logger', (logger) => logger.log(message, toasterOptions)])

export const logError = (error: string, toasterOptions?: ToasterOptions) =>
  injector &&
  injector.invoke([
    'logger',
    (logger) => logger.logError(error, toasterOptions)
  ])

export const logSuccess = (message: string, toasterOptions?: ToasterOptions) =>
  injector &&
  injector.invoke([
    'logger',
    (logger) => logger.logSuccess(message, toasterOptions)
  ])

export const logClear = () =>
  injector && injector.invoke(['logger', (logger) => logger.clear()])
